import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import { removeEmptyParams } from 'utils/services';

import {
  ApiResponse,
  adaptApiToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import type { ClientInfoDto } from './dto';
import { mapClientInfoListDtoToModel } from './mappers';
import type { ClientInfo, GetClientsFilterParams } from './models';

const CLIENT_NAMES_PATH = '/management/clients/names';

export const getClientsFilter = async (
  params: GetClientsFilterParams,
): Promise<GenericResponse<ApiResponse<ClientInfo[]>>> => {
  try {
    const queryParams: Record<string, unknown> = {
      rol: params.role,
      filterBy: params.filterBy,
      filterValue: params.name,
      amib: params.amib,
    };
    removeEmptyParams(queryParams);

    const response = await wtClientApi.get<ApiResponse<ClientInfoDto[]>>(
      CLIENT_NAMES_PATH,
      { params: queryParams },
    );

    const mappedResponse: ApiResponse<ClientInfo[]> = {
      ...response.data,
      data: mapClientInfoListDtoToModel(response.data.data ?? []),
    };

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al obtener los datos del cliente',
    );
  }
};
